import MainHeader from '../../../layouts/MainHeader'
import Footer from '../../../layouts/Footer';
import BorderLeftBox from '../../../components/boxes/BorderLeftBox';
import ScrollView from '../../../components/ScrollView/ScrollView';
import CardThree from '../../../components/cards/CardThree';
import sustainableProductsPageDataAr from '../../../data/arabic/subpages/sustainalbe-products-page-data-ar';

const SustainableProductsPageAr = () => {
    return (
        <main className="page" id="main">
          <div className="sticky-view-two">
            <div className="sticky-container">
              <MainHeader
                title=""
                image={{
                  src: require(`../../../assets/images/backgrounds/sustainable-project.jpg`),
                  alt: "Sustainable Product and Services",
                }}
              />
            </div>
            <div className="sticky-container-two">
              <div className="wrapper-small">
                <h1 className="title-center">
                  {sustainableProductsPageDataAr.mainTitle}
                </h1>
              </div>
              <div className="wrapper-small">
                <ScrollView>
                {sustainableProductsPageDataAr.sectionOne.map((item, index) => (
                <CardThree
                  key={index}
                  title={item.title}
                  subtitle={item.subtitle}
                  icon={{
                    src: require(`../../../assets/icons/environment/${item.icon}`),
                    alt: "",
                  }}
                />
              ))}
                </ScrollView>
              </div>
              
              <div className="space-50"></div>
              <div className="space-50"></div>
              <div className="wrapper-small">
                <BorderLeftBox
                  title={sustainableProductsPageDataAr.sectionTwo.borderBox.title}
                  subtitle={
                    sustainableProductsPageDataAr.sectionTwo.borderBox.subtitle
                  }
                />
                <p className="text-paragraph">
                  {sustainableProductsPageDataAr.sectionTwo.paragraphTwo}
                </p>
                <div className="table-wrapper">
                  <table className="table-secondary">
                    <thead>
                      <tr aria-hidden="true"></tr>
                      <tr>
                        <th>
                          {
                            sustainableProductsPageDataAr.sectionTwo.tableOne
                              .headers[0]
                          }
                        </th>
                      </tr>
                    </thead>
                  </table>
                  <p className="text-note">
                  يتيح حساب الودائع الخضراء من بنك الأول للعملاء إيداع أموالهم بأمان لدعم تمويل المشاريع الصديقة للبيئة، وتحقيق عوائد تنافسية مجزية على الاستثمارات القصيرة والمتوسطة المدى.
                  </p>
                  <table className="table-secondary">
                    <tbody>
                      {sustainableProductsPageDataAr.sectionTwo.tableOne.data.map(
                        (item, index) => (
                          <tr key={index}>
                            <td className="mnw-200">
                              <b>{item[0]}</b>
                            </td>
                            <td>{item[1]}</td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
                <BorderLeftBox
                  title={sustainableProductsPageDataAr.sectionTwo.borderBoxTwo.title}
                  subtitle={
                    sustainableProductsPageDataAr.sectionTwo.borderBoxTwo.subtitle
                  }
                />
              </div>
              <div className="space-50"></div>
              <div className="space-50"></div>
              <Footer withBlogs={false} />
            </div>
          </div>
        </main>
      );
}

export default SustainableProductsPageAr